module.exports = __webpack_public_path__ + "static/media/AstroBearLogoInverse.5aa6b609.png";